export const authTypes = {
  LOGIN: 'LOGIN',
  ERROR_MSG: 'ERROR_MSG',
  GET_USERS_LIST: 'GET_USERS_LIST',
  ROOT_LOGIN: "ROOT_LOGIN",
  ROOT_ERROR_MSG: "ROOT_ERROR_MSG",
}